import React, { useState, useEffect } from 'react';
import LogAction from '../Utilities/LogAction';
import TopMenuNavigationLogo from '../TopMenuNavigation/TopMenuNavigationLogo';
import TopMenuNavigationContact from '../TopMenuNavigation/TopMenuNavigationContact';
import { stariaForm } from '../../../data/formsData';
import Form from '../Form/Form';
import SectionHeader from '../Neutral/SectionHeader';
import ContactPageInfo from '../ContactPage/ContactPageInfo';
import StariaMain from '../../../assets/Staria.png';

import Carousel from '../Neutral/Carousel';
import PriceList from './PriceList';
import ScrollToTopButton from '../Utilities/ScrollToTopBotton'; // Import the ScrollToTopButton component
import ContactPagePhone from '../ContactPage/ContactPagePhone';

// Function to import all images from a directory
function importAll(r) {
    return r.keys().map(r);
}

// Import all images from the assets/Modele/Tucson directory
const images = importAll(require.context('../../../assets/Modele/Staria', false, /\.(png|jpe?g|svg)$/));

const initialFormState = {
    name: '',
    email: '',
    phone: '',
    marketing: false,
    marketing_sms: false,
    marketing_phone: false,
    marketing_email: false,
};

function ModelStariaPage() {
    const [formData, setFormData] = useState(initialFormState);
    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        LogAction('User entered the StariaPage');

        return () => {
            LogAction('User left the StariaPage');
        };
    }, []);

    const validate = () => {
        const newErrors = {};
        const { marketing_phone, marketing_email } = formData;

        if (!marketing_phone && !marketing_email) {
            newErrors.contact = "At least one contact method (marketing phone or marketing email) is required.";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleRestart = () => {
        setIsSubmitted(false);
        setFormData(initialFormState);
    };

    if (isSubmitted) {
        return (
            <div className="form-summary">
                <p>Dziękujemy za przesłanie formularza. Nasz Doradca skontaktuje się z Tobą w przeciągu kilku godzin.</p>
                <button onClick={handleRestart}>Wróć do formularza</button>
            </div>
        );
    }

    return (
        <>
            <header className='topmenunavigation animation-container'>
                <TopMenuNavigationLogo />
                <TopMenuNavigationContact />
            </header>
            <div className='grid-page'>
                <div className='grid-page-1 model-baner-staria animation-container'>
                    <img src={StariaMain} alt="Staria" />
                    <h1>Nowy Hyundai Staria</h1>
                    <h2>Wybierz wersję 7 lub 9 miejscową</h2>
                </div>
                <SectionHeader title='Hyundai Staria. Zamów już dziś, odbierz do końca roku.' />
                <div className="grid-page-2-3 article-two-third ">
                    <div className="grid-page-2-3-sub grid-color-white model-configuration animation-container">
                        
                        <h2>Cena zaczyna się od <strong className='model-price'>199 900</strong> brutto.</h2>
                
                        <h3>Nieograniczone możliwości.</h3>
                        <p>W tej przestrzeni Twoje możliwości są nieograniczone. Wsiądź do nowego Hyundaia STARIA i doświadcz wyjątkowego komfortu i wszechstronności wspieranych przez najwyższy poziom bezpieczeństwa i łączności.</p>
                        <h3>Styl, przestrzeń i funkcjonalność.</h3>
                        <p>Oszczędny napęd hybrydowy. Nie rób nic. Po prostu korzystaj. Nowa STARIA pozwala przejechać więcej kilometrów na jednym litrze benzyny, dzięki wsparciu energii elektrycznej. Bez potrzeby ładowania akumulatora i bez zmiany Twoich nawyków za kierownicą. Silniki benzynowy i elektryczny tworzą układ hybrydowy, w którym akumulator ładuje się samoczynnie podczas hamowania. Ty jedziesz dalej. I dłużej.</p>
                        <h3>3-letnia gwarancja bez limitu kilometrów.</h3>
                        <p>Jak każdy Hyundai, nowa STARIA została zbudowana zgodnie z najwyższymi standardami jakości. Tę jakość wspieramy 3-letnią gwarancją bez limitu kilometrów, abyś mógł cieszyć się życiem bez martwienia się o swój samochód. Korzystaj z dodatkowego spokoju ducha, który zapewnia jedna z najlepszych gwarancji w branży.</p>
                    </div>
                    <div className="grid-page-2-3-sub article-content grid-color-white animation-container">
                        <Form 
                            formData={stariaForm} 
                            formDataValues={formData}
                            setFormData={setFormData}
                            setErrors={setErrors}
                            setIsSubmitted={setIsSubmitted}
                            setIsLoading={setIsLoading}
                            errors={errors}
                            isLoading={isLoading}
                        />
                        <p>Wypełniając powyzszy formularz, wyrazasz zgodę na skontaktowanie się z Tobą. Twoje dane nie zostaną wykorzystane do marketingu przyszłego. <a href='/polityka-prywatnosci'>Kliknij tu po więcej informacji</a></p>
                    </div>
                </div>
                
                <SectionHeader title='Cenniki' />
                
                <div className='grid-page-1 grid-color-white animation-container'>
                    <PriceList modelName='staria' />
                </div>
                <SectionHeader title='Przekonaj się sam' />
                <div className='model-photos animation-container'>
                    <Carousel interval={5000} height='600px' data={images.map(image => ({ image }))} />
                </div>
                
                <SectionHeader title='Odwiedź nasz salon' />
                <div className='grid-page-1 animation-container grid-color-white'>
                    <ContactPageInfo />
                </div>
                <SectionHeader title='Skontaktuj się z nami' />
                <div className='grid-page-2 animation-container grid-color-white'>
                    <div className=''>
                        <Form 
                            formData={stariaForm} 
                            formDataValues={formData}
                            setFormData={setFormData}
                            setErrors={setErrors}
                            setIsSubmitted={setIsSubmitted}
                            setIsLoading={setIsLoading}
                            errors={errors}
                            isLoading={isLoading}
                        />
                        <p>Wypełniając powyzszy formularz, wyrazasz zgodę na skontaktowanie się z Tobą. Twoje dane nie zostaną wykorzystane do marketingu przyszłego. 
                            <a href='/polityka-prywatnosci'>Kliknij tu po więcej informacji</a>
                        </p>
                        
                    </div>
                    <div>
                        <ContactPagePhone />
                    </div>
                </div>
            </div>
            <ScrollToTopButton /> {/* Add the ScrollToTopButton component */}
        </>
    );
}

export default ModelStariaPage;
